document.addEventListener('DOMContentLoaded', () => {
  document.addEventListener('click', (e) => {
    // Open modal
    if (e.target.closest('.info-modal-button')) {
      document.querySelector(".info-modal-overlay").classList.add("info-modal-active");
    }
    
    // Close modal by close button
    if (e.target.closest('.info-modal-close')) {
      document.querySelector(".info-modal-overlay").classList.remove("info-modal-active");
    }
    
    // Close modal when clicking outside
    if (e.target.classList.contains("info-modal-overlay")) {
      e.target.classList.remove("info-modal-active");
    }
  });
});


document.addEventListener("click", function(event) {
  const button = event.target.closest(".remi-package-protection-btn");
  if (button) {
    var variantId = button.getAttribute('data-id');

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        id: parseInt(variantId),
        quantity: 1
      })
    })
    .then(response => {
      if (!response.ok) {
        throw new Error('Failed to add to cart');
      }
      return response.json();
    })
    .then(data => {
      window.location.href = '/checkout';
    })
    .catch(error => {
      console.error('Error:', error);
    });
  }
});



